import { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext"; 

const useHeatMap = () => {

  const { api } = useContext(GlobalContext);

const trackClick = async (requestBody) => {
  try {
    const response = await api.post(
      "/api/Blog/trackClickHeatMaps",
      requestBody,
    );
    return true;
  } catch (error) {
    console.error("Error tracking click:", error);
    return false;
  }
};
  return { trackClick };
};

export default useHeatMap;